import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient} from '@angular/common/http';
import { MessageService } from './message.service';
import { ConfigLoaderService } from '../config/configloader.service';
import { MpcBoardConfiguration } from '../models/mpcboard/mpcBoardConfiguration';
import { map } from 'rxjs/operators';

/**
 * this class represents access to all rest requests concerning Mpc Board data of the PyWall
 */
@Injectable()
export class MpcboardService {
  private projectBaseURL: string;
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private configService: ConfigLoaderService) {
    const pyWallUrl = this.configService.settings.pyWallServer.url;
    this.projectBaseURL = `${pyWallUrl}mpcboard`;
  }

  create(data: MpcBoardConfiguration): void {
    this.messageService.sendDebug('MpcBoardService create called.');
    const targetURL = this.projectBaseURL;
    this.http.put<MpcBoardConfiguration>(targetURL, data).subscribe({
      error: (error) => {
        this.messageService.sendWarn(`Couldn't create MpcBoardConfiguration on program ${data.programKey}, ${error}`);
      }
    });
  }

  /**
   * returns the mpc board configuration of a program
   */
  getMpcBoardConfiguration(programId: number): Observable<MpcBoardConfiguration> {
    this.messageService.sendDebug(`MpcBoardService getMpcBoardConfiguration on ${programId} called.`);
    const targetURL = this.projectBaseURL + `/${programId}/`;
    return this.http.get<MpcBoardConfiguration>(targetURL).pipe(map(result =>
      new MpcBoardConfiguration(result.id, result.programKey, result.visibleTeams, result.teams, result.sprints)));
  }

  /**
   * updates the mpc board configuration of a program
   */
  updateMpcBoardConfiguration(data: MpcBoardConfiguration): void {
    this.messageService.sendDebug(`MpcBoardService updateMpcBoardConfiguration on ${data.programKey} called.`);
    const targetURL = this.projectBaseURL + `/${data.programKey}/`;
    this.http.put<MpcBoardConfiguration>(targetURL, data).subscribe({
      error: (error) => {
        this.messageService.sendWarn(`Couldn't update MpcBoardConfiguration ${data.id} on program ${data.programKey}, ${error}`);
      }
    });
  }
}
